module.exports = __webpack_public_path__ + "media/images/bsmart/icons/side_menu_gruppi-2f2f3afd9a8ef2638b7fe3a3176f8640.svg";